export default "__VITE_ASSET__ChLKEEGX__"